import React, { useMemo } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { useWhoIsOnlineContext } from "../../WhoIsOnline/context/index.jsx";

export const UserOnlineStatus = ({ id, children, isUserCard }) => {
  const { members } = useWhoIsOnlineContext();

  const online = useMemo(() => !!members?.some((userId) => userId === id), [id, members]);

  return (
    <div
      data-testid="user-online-status"
      className={classnames("user-status", {
        "user-status--online": online,
        "user-status--user-card": isUserCard,
      })}
    >
      {children}
    </div>
  );
};

UserOnlineStatus.propTypes = {
  id: PropTypes.number,
  children: PropTypes.node,
  isUserCard: PropTypes.bool,
};

UserOnlineStatus.defaultProps = {
  isUserCard: false,
};
